export enum Region {
    NorthAmerica = 1,
    LatinAmerica = 2,
    Europe = 4,
    Asia = 8,
    Brazil = 16,
    All = NorthAmerica | LatinAmerica | Europe | Asia | Brazil,
}
